import { Injectable } from '@angular/core';

import { SpaContext } from '../../../Classes/spacontext';
import { VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { MessagingConversationApiModel } from './Models/MessagingConversationApiModel';

@Injectable()
export class MessagingServiceV2 {
	readonly baseUri = '/api/Client/v2/MessagingConversations';

	constructor(private http: VisibaApiHttp) {}

	public getAll() {
		return this.http.getTyped<MessagingConversationApiModel[]>(`${this.baseUri}`);
	}

	public get(id: number) {
		return this.http.getTyped<MessagingConversationApiModel>(`${this.baseUri}/case/${id}`);
	}
}
